// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"305":"0263d763","377":"3b9abf0c","495":"6d0f8c52","861":"fb3d6961","924":"ee2af413"}[chunkId] + ".chunk.css";
};